document.addEventListener("DOMContentLoaded", function () {
  // Open popup
  document
    .querySelector("#open-product-request")
    .addEventListener("click", (e) => {
      e.preventDefault();
      document
        .querySelector(".notification-request-popup")
        .classList.add("show");
      document.querySelector(".popup-overlay").classList.add("show");
      document.body.style.overflow = "hidden";
    });

  // Close popup when clicking on overlay
  document.querySelector(".popup-overlay").addEventListener("click", () => {
    document
      .querySelector(".notification-request-popup")
      .classList.remove("show");
    document.querySelector(".popup-overlay").classList.remove("show");
    document.body.style.overflow = "auto";
  });

  // Close popup when clicking the close button (if added)
  const closeButtons = document.querySelectorAll(
    ".close-popup, .js-close-notification",
  );
  closeButtons.forEach((button) => {
    button.addEventListener("click", () => {
      document
        .querySelector(".notification-request-popup")
        .classList.remove("show");
      document.querySelector(".popup-overlay").classList.remove("show");
      document.body.style.overflow = "auto";
    });
  });
});
